<template>
  <div>
    <h2>Account löschen</h2>

    <div class="container-fluid">
      <br>
      <strong>Bist du dir sicher, dass du deinen Account löschen möchtest?<br>Dieser Vorgang kann nicht rückgängig gemacht werden und es werden alle deine Daten gelöscht!</strong>
      <form class="user" v-on:submit.prevent="onSubmit">
        <div class="form-group row">
          <div class="col-lg-3">
            <br>
            <input type="checkbox" id="ja" value="1" v-model="confirmed">
            <label class="mx-2" for="ja">Ja, ich bin mir sicher.</label>
            <br><br>
            <button v-if='confirmed' type="submit" class="btn btn-danger btn-user btn-block">Jetzt löschen</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>

  import UserRegisterService from '../services/UserRegisterService'

  export default {
    name: 'UserDelete',
    data () {
      return {
        confirmed: false
      }
    },
    methods: {
      onSubmit () {
        UserRegisterService.deleteAccount()
          .then(response => {
            this.$router.push('/seeyou')
          })
          .catch(e => {
            this.$alert('Es ist ein unerwarteter Fehler aufgetreten!')
          })
      }
    }
  }
</script>

<style>
</style>
